export default __webpack_public_path__ + "static/media/tick.fb52eed9.svg";